// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  COMMON_TOGGLE_SIDEBAR,
} from './constants';

export function toggleSidebar(direction, value) {
  return {
    type: COMMON_TOGGLE_SIDEBAR,
    dir: direction,
    value
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COMMON_TOGGLE_SIDEBAR:
      let sidebarLeft = (action.dir === 'left' && action.value)
        ? true
        : false
      let sidebarRight = (action.dir === 'right' && action.value)
        ? true
        : false
      return {
        ...state,
        sidebarLeft,
        sidebarRight,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/common/redux/toggleSidebar.js